<template>
  <div id="expensesApprovedComponent">
    <page-title
      :heading="heading"
      :subheading="subheading"
      :icon="icon"
    ></page-title>
    <v-container>
      <v-layout class="mb-2">
        <v-flex xs12 md6>
          <v-alert
            icon="info"
            :value="true"
            color="primary"
            outline
            v-if="showMessageAddItem"
          >
            <h3 class="mb-0">
              {{ $t('expenseRejected.addExpensesRejectedMessage') }}
            </h3>
          </v-alert>
        </v-flex>
        <v-flex>
          <v-dialog
            scrollable
            persistent
            v-model="dialogNoFiscal"
            max-width="700px"
          >
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">
                  {{ $t('workflowValidation.reject') }}
                  <span>( {{ putItem.receipt_type.name }} )</span>
                </h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-md>
                  <v-form ref="formNF" lazy-validation v-model="valid2">
                    <v-layout wrap>
                      <v-flex xs12 md6>
                        <v-menu
                          v-model="datemenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              :label="$t('general.date')"
                              prepend-icon="event"
                              v-on="on"
                              v-model="putItem.date"
                              :rules="rules.required"
                            >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            :locale="$t('general.locale')"
                            v-model="putItem.date"
                            @input="datemenu = false"
                            :max="date"
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-autocomplete
                          :label="$t('general.category')"
                          v-model="putItem.gst_categories_id"
                          :items="categories"
                          item-text="name"
                          item-value="id"
                          :rules="rules.required"
                        >
                          <template slot="selection" slot-scope="data">
                            {{ data.item.name }}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ data.item.name }}
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-autocomplete
                          :label="$t('general.country')"
                          v-model="putItem.country.id"
                          :items="satPais"
                          item-text="descripcion"
                          item-value="id"
                          :rules="rules.required"
                          :filter="countryFilter"
                        >
                          <template slot="selection" slot-scope="data">
                            {{ data.item.c_Pais }} - {{ data.item.descripcion }}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ data.item.c_Pais }} - {{ data.item.descripcion }}
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          :label="$t('general.description')"
                          v-model="putItem.description"
                          :rules="rules.required"
                        >
                        </v-textarea>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-autocomplete
                          :label="$t('general.currency')"
                          v-model="putItem.currency.id"
                          :items="satMoneda"
                          item-text="descripcion"
                          item-value="id"
                          :rules="rules.required"
                          :filter="currencyFilter"
                        >
                          <template slot="selection" slot-scope="data">
                            {{ data.item.c_Moneda }} -
                            {{ data.item.descripcion }}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ data.item.c_Moneda }} -
                            {{ data.item.descripcion }}
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          :label="$t('general.exchangeRate')"
                          v-model="putItem.exchange"
                          :rules="rules.required"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          :label="$t('general.subtotal')"
                          v-model="putItem.subtotal"
                          :rules="rules.required"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          :label="$t('general.total')"
                          v-model="putItem.total"
                          :rules="rules.required"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-autocomplete
                          :label="$t('general.formaPago')"
                          v-model="putItem.sat_formaPago_id"
                          :items="satFormaPago"
                          item-text="descripcion"
                          item-value="id"
                          :rules="rules.required"
                        >
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          :label="
                            $t('general.folioRef') + $t('general.optionalField')
                          "
                          v-model="putItem.folio"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <label>{{ $t('general.image') }}:</label>
                        <v-btn
                          v-if="!isPDF(dataURL)"
                          depressed
                          color="primary"
                          block
                          @click="viewImg = !viewImg"
                        >
                          <v-icon left>{{
                            viewImg === false ? 'visibility' : 'visibility_off'
                          }}</v-icon>
                          {{
                            viewImg === false
                              ? $t('workflowValidation.showImage')
                              : $t('workflowValidation.hideImage')
                          }}
                        </v-btn>
                        <v-btn
                          block
                          v-if="isPDF(dataURL)"
                          @click="openPDF()"
                          color="primary"
                          depressed
                        >
                          <v-icon left>insert_drive_file</v-icon>
                          {{ $t('expenseItems.watchFile') }}
                        </v-btn>
                        <div v-if="viewImg === true">
                          <a v-if="!isPDF(dataURL)" @click="openPDF()">
                            <zoom-on-hover
                              :img-normal="dataURL"
                            ></zoom-on-hover>
                          </a>
                        </div>
                        <label>{{
                          $t('workflowValidation.changeImage')
                        }}</label>
                        <vue-dropzone
                          ref="dropzone"
                          id="dropzone"
                          :options="dropzoneOptions"
                          v-on:vdropzone-file-added="fileAdded"
                          v-on:vdropzone-error="fileUploadError"
                          v-on:vdropzone-success="fileUpload"
                        >
                        </vue-dropzone>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          :label="$t('general.comment')"
                          v-model="putItem.comment"
                        >
                        </v-textarea>
                      </v-flex>
                      <v-flex xs6 sm6 md6>
                        <v-flex cols="12">
                          <v-autocomplete
                            :label="$t('expenses.name')"
                            :items="expensesOpen"
                            item-text="description"
                            item-value="id"
                            v-model="expense.id"
                          >
                            <template slot="item" slot-scope="data">
                              {{ data.item.id }} - {{ data.item.description }}
                            </template>
                          </v-autocomplete>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" round flat @click="close">
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                  color="primary"
                  round
                  class="white--text"
                  :loading="loading"
                  :disabled="loading"
                  @click="saveEdit"
                >
                  {{ $t('general.save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
        <v-flex>
          <v-dialog persistent v-model="dialogFiscal" max-width="600px">
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">
                  {{ $t('workflowValidation.reject') }}
                  <span>( {{ putItemF.receipt_type.name }} )</span>
                </h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-md>
                  <v-form ref="formF" lazy-validation v-model="valid3">
                    <v-layout wrap>
                      <v-flex xs12 md12>
                        <v-text-field
                          label="UUID"
                          disabled
                          v-model="putItemF.uuid"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          :label="$t('general.date')"
                          prepend-icon="event"
                          v-model="putItemF.date"
                          disabled
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-autocomplete
                          :label="$t('general.category')"
                          v-model="putItemF.gst_categories_id"
                          :items="categories"
                          item-text="name"
                          item-value="id"
                        >
                          <template slot="selection" slot-scope="data">
                            {{ data.item.name }}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ data.item.name }}
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-autocomplete
                          :label="$t('general.country')"
                          v-model="putItemF.country.id"
                          :items="satPais"
                          item-text="descripcion"
                          item-value="id"
                          :filter="countryFilter"
                          disabled
                        >
                          <template slot="selection" slot-scope="data">
                            {{ data.item.c_Pais }} - {{ data.item.descripcion }}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ data.item.c_Pais }} - {{ data.item.descripcion }}
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          :label="$t('general.description')"
                          v-model="putItemF.description"
                          disabled
                        >
                        </v-textarea>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-autocomplete
                          :label="$t('general.currency')"
                          v-model="putItemF.currency.id"
                          :items="satMoneda"
                          item-text="descripcion"
                          item-value="id"
                          :filter="currencyFilter"
                          disabled
                        >
                          <template slot="selection" slot-scope="data">
                            {{ data.item.c_Moneda }} -
                            {{ data.item.descripcion }}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ data.item.c_Moneda }} -
                            {{ data.item.descripcion }}
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          :label="$t('general.exchangeRate')"
                          v-model="putItemF.exchange"
                          disabled
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          :label="$t('general.subtotal')"
                          v-model="putItemF.subtotal"
                          disabled
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          :label="$t('general.total')"
                          v-model="putItemF.total"
                          disabled
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-autocomplete
                          :label="$t('general.formaPago')"
                          v-model="putItemF.sat_formaPago_id"
                          :items="satFormaPago"
                          item-text="descripcion"
                          item-value="id"
                          disabled
                        >
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-autocomplete
                          :label="$t('general.metodoPago')"
                          v-model="putItemF.sat_metodoPago_id"
                          :items="satMetodoPago"
                          item-text="descripcion"
                          item-value="id"
                          disabled
                        >
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-text-field
                          :label="$t('general.folioRef')"
                          v-model="putItemF.folio"
                          disabled
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          :label="$t('general.comment')"
                          v-model="putItemF.comment"
                        >
                        </v-textarea>
                      </v-flex>
                      <v-flex xs6 sm6 md6>
                        <v-flex cols="12">
                          <v-autocomplete
                            :label="$t('expenses.name')"
                            :items="expensesOpen"
                            item-value="id"
                            item-text="description"
                            v-model="expense.id"
                          >
                            <template slot="item" slot-scope="data">
                              {{ data.item.id }} - {{ data.item.description }}
                            </template>
                          </v-autocomplete>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" round flat @click="close">
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                  color="primary"
                  round
                  class="white--text"
                  @click="saveEditF"
                >
                  {{ $t('general.save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-dialog v-model="dialogComment" max-width="500px" persistent>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black info--text mb-0">
                  {{ $t('workflowValidation.commentV') }}
                </h2>
              </v-toolbar>
              <v-card-text>
                <v-form lazy-validation ref="formC">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        {{ comment.validator_comment }}
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info darken-1" round flat @click="close">
                  {{ $t('general.close') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
        <v-flex class="text-xs-right" v-if="itemsBack.length > 0">
          <v-btn
            color="primary"
            round
            outline
            to="/expenses"
            v-show="showMessageAddItem"
          >
            <v-icon left>fas fa-file-invoice-dollar fa-fw icon-color</v-icon>
            {{ $t('expenseRejected.goChecks') }}
          </v-btn>
          <v-btn
            color="primary"
            round
            outline
            @click="showDialogSelectExpenses"
            v-if="selected.length > 0"
          >
            {{ $t('expenses.selectExpense') }}
          </v-btn>
          <v-dialog
            v-model="dialogRedirect"
            max-width="900px"
            persistent
            scrollable
            v-if="expenses.length > 0"
          >
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">
                  {{ title }}
                </h2>
              </v-toolbar>
              <v-card-text>
                <v-layout class="my-3">
                  <v-flex xs8>
                    <h3>
                      <span class="font-weight-black primary--text"
                        >{{ $t('general.description') }}:</span
                      >
                      {{ expense.description }}
                    </h3>
                    <h3>
                      <span class="font-weight-black primary--text"
                        >{{ $t('general.project') }}:</span
                      >
                      {{
                        expense.project_id
                          ? getProject(expense.project_id).name
                          : ''
                      }}
                    </h3>
                  </v-flex>
                  <v-flex xs4>
                    <h3>
                      <span class="font-weight-black primary--text"
                        >{{ $t('general.startDate') }}:</span
                      >
                      {{ expense.start_date }}
                    </h3>
                    <h3>
                      <span class="font-weight-black primary--text"
                        >{{ $t('general.endDate') }}:</span
                      >
                      {{ expense.end_date }}
                    </h3>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <h3 class="font-weight-black primary--text my-4">
                  {{ $t('workflowValidation.selectItems') }}:
                </h3>
                <v-data-table
                  v-model="selected"
                  :search="search"
                  class="elevation-2"
                  :headers="addingHeaders"
                  :items="itemsBack"
                  :loading="loadingItems"
                  :rows-per-page-items="[10, 15, 25]"
                  :pagination.sync="pagination"
                  select-all
                  item-key="id"
                >
                  <template v-slot:headers="props">
                    <tr class="bg-heavy-rain">
                      <th>
                        <v-checkbox
                          :input-value="props.all"
                          :indeterminate="props.indeterminate"
                          color="primary"
                          hide-details
                          @click.stop="toggleAll"
                        ></v-checkbox>
                      </th>
                      <th
                        v-for="header in props.headers"
                        :key="header.text"
                        :class="[
                          'column',
                          header.sortable ? 'sortable' : '',
                          pagination.descending ? 'desc' : 'asc',
                          header.value === pagination.sortBy ? 'active' : '',
                        ]"
                        @click="changeSort(header.value)"
                      >
                        <h2 class="font-weight-black primary--text mb-0">
                          <v-icon
                            small
                            class="primary--text"
                            v-if="header.sortable"
                            >arrow_upward</v-icon
                          >
                          {{ header.text }}
                        </h2>
                      </th>
                    </tr>
                  </template>
                  <template v-slot:items="props">
                    <tr
                      :active="props.selected"
                      @click="props.selected = !props.selected"
                    >
                      <td>
                        <v-checkbox
                          :input-value="props.selected"
                          color="primary"
                          hide-details
                        ></v-checkbox>
                      </td>
                      <td class="text-sm-center">{{ props.item.id }}</td>
                      <td class="text-sm-center">
                        {{
                          props.item.receipt_type
                            ? props.item.receipt_type.name
                            : '- -'
                        }}
                      </td>
                      <td class="text-sm-center">
                        {{ props.item.description }}
                      </td>
                      <td class="text-sm-center">
                        {{ props.item.validator_comment }}
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" round flat @click="close">
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                  color="primary"
                  round
                  depressed
                  :loading="loading"
                  :disabled="loading"
                  @click="saveRedirect"
                >
                  {{ $t('general.save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="xs12">
          <v-toolbar flat color="bg-sidebar" dark>
            <h2 class="my-0">{{ $t('general.rejected') }}</h2>
          </v-toolbar>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="itemsBack"
            :search="search"
            class="elevation-1"
            :rows-per-page-items="[10, 15, 25]"
            :pagination.sync="pagination"
            :loading="loadingItems"
          >
            <template v-slot:headers="props">
              <tr class="bg-heavy-rain">
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column',
                    header.sortable ? 'sortable' : '',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                <div style="display: flex; align-items: center;">
                  <v-checkbox v-if="header.text === '#'" :input-value="props.all" :indeterminate="props.indeterminate" color="primary" hide-details @click.stop="toggleAll"></v-checkbox>
                  <h2 class="font-weight-black primary--text mb-0">
                    <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                    {{ header.text }} {{ header.value === 'total' ? tagCurrency : '' }}
                  </h2>
                </div>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr :active="props.selected">
                <td class="text-sm-center">
                  <div style="display: flex; align-items: center;">
                    <v-checkbox
                    :input-value="props.selected"
                    color="primary"
                    hide-details
                    v-model="props.selected"
                  ></v-checkbox>
                  {{ props.item.id }}
                  </div>
                </td>
                <td class="text-sm-center">
                  {{
                    props.item.receipt_type
                      ? props.item.receipt_type.name
                      : '- -'
                  }}
                </td>
                <td class="text-sm-center">
                  <b>{{ props.item.description }}</b>
                  <div v-if="props.item.expense_amex_id !== null">
                    <br>
                    <span class="fontSize">{{ $t('general.reasonForRejection') }} : {{props.item.validator_comment}}</span>
                  </div>
                </td>
                <td class="text-sm-center">
                  <b v-if="props.item.gst_receipt_types_id === 1">{{ props.item.issuer_name || props.item.issuer_tax }}</b>
                  <b v-if="props.item.gst_receipt_types_id === 3 && props.item.vendor !== null">{{ props.item.vendor.name }}</b>
                  <br>
                  <span class="fontSize">{{ props.item.uuid }}</span>
                </td>
                <td class="text-sm-center">
                  {{ props.item.total | formatCurrency }}
                </td>
                <td class="text-sm-center">
                  {{
                    props.item.expenses_amex_id
                      ? props.item.expenses_amex_id
                      : '- -'
                  }}
                </td>
                <td class="text-sm-center">
                  <v-chip
                    :color="
                      props.item.validator_comment === null ? 'green' : 'red'
                    "
                    class="font-weight-black"
                    dark
                    small
                  >
                    {{
                      props.item.validator_comment === null
                        ? $t('expenses.statExpense.new')
                        : $t('expenses.statExpense.rejected')
                    }}
                  </v-chip>
                </td>
                <td class="text-sm-center text-justify">
                  <v-layout row>
                    <v-flex
                      justify-center
                      v-if="props.item.receipt_type.name === 'no fiscal' || props.item.receipt_type.id === 3"
                    >
                      <v-tooltip bottom color="primary">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            small
                            @click="viewItem(props.item)"
                            icon
                            outline
                            color="primary"
                            v-on="on"
                          >
                            <v-icon small>edit</v-icon>
                          </v-btn>
                        </template>
                        <span
                          >{{ $t('workflowValidation.viewItem') }} ({{ props.item.receipt_type.name }}) </span
                        >
                      </v-tooltip>
                    </v-flex>
                    <v-flex justify-center v-else>
                      <v-tooltip bottom color="primary">
                        <template v-slot:activator="{ on }">
                          <v-btn
                            small
                            @click="viewItemf(props.item)"
                            icon
                            outline
                            color="primary"
                            v-on="on"
                          >
                            <v-icon small>edit</v-icon>
                          </v-btn>
                        </template>
                        <span
                          >{{
                            $t('workflowValidation.viewItem')
                          }}
                          (fiscal)</span
                        >
                      </v-tooltip>
                    </v-flex>
                    <v-flex v-if="props.item.validator_comment !== null">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            small
                            color="#F7665E"
                            @click="confirmDelete(props.item)"
                            outline
                            icon
                            v-on="on"
                          >
                            <v-icon small>mdi-trash-can</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('viatics.deleteRequest') }}</span>
                      </v-tooltip></v-flex
                    >
                  </v-layout>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <!-- <v-flex xs4 v-if="expenses.length > 0">
          <v-toolbar flat color="bg-sidebar" dark>
            <h2 class="my-0">{{$t('general.expenses')}}</h2>
          </v-toolbar>
          <v-data-table
          :search="search"
          class="elevation-2"
          :headers="expensesHeaders"
          :items="expenses"
          :loading="loadingItems"
          :pagination.sync="pagination"
          hide-actions
          >
            <template v-slot:headers="props">
              <tr class="bg-heavy-rain">
                <th
                v-for="header in props.headers"
                :key="header.text"
                :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                  @click="changeSort(header.value)"
                >
                  <h2 class="font-weight-black primary--text mb-0">
                    <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                    {{header.text}}</h2>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-sm-center">{{props.index + 1}}</td>
                <td class="text-sm-center">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        style="vertical-align: middle"
                        v-if="props.item.is_petty_cash === 1"
                        class="primary--text"
                        v-on="on"
                      >stars</v-icon>
                    </template>
                    <span>{{ $t('expenses.pettyExpense') }}</span>
                  </v-tooltip>
                  {{props.item.description}}
                </td>
                <td class="text-sm-center text-justify">
                  <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        @click="addItems(props.item)"
                        small
                        icon
                        color="primary"
                        v-on="on">
                        <v-icon small>add</v-icon>
                      </v-btn>
                    </template>
                    <span>{{$t('workflowValidation.add')}}</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex> -->
      </v-layout>
      <v-dialog
        v-model="dialogSelectExpenses"
        max-width="900px"
        scrollable
        persistent
      >
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenses.relateExpense') }}
            </h2>
          </v-toolbar>
          <v-card-text>
            <v-layout class="my-3">
              <v-flex xs8>
                <h3 class="font-weight-black primary--text">
                  {{ $t('expenses.selectExpense') }}
                </h3>
              </v-flex>
              <v-flex xs4>
                <v-btn
                  color="primary"
                  class="pr-2"
                  @click="showDialogExpenses()"
                  round
                  outline
                >
                  <v-icon left>attach_money</v-icon>
                  {{ $t('expenses.add') }}
                </v-btn>
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="headers2"
              :items="expensesOpen"
              no-data-text="No hay datos que mostrar"
              hide-default-footer
              disable-pagination
              hide-actions
              :pagination.sync="paginationExpenses"
              :footer-props="{ 'items-per-page-options': [-1] }"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <tr
                  @click="selectRow(props.item)"
                  class="rowExpense"
                  :class="{ selectedRow: props.item.isSelected }"
                  :key="props.index"
                >
                  <td class="text-sm-center">{{ props.item.id }}</td>
                  <td class="text-sm-center">{{ props.item.description }}</td>
                  <td class="text-sm-center">
                    {{ props.item.start_date }} - {{ props.item.end_date }}
                  </td>
                  <td class="text-sm-center">{{ props.item.project.name }}</td>
                  <td class="text-sm-center">{{ props.item.advance }}</td>
                  <td class="text-sm-center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          small
                          outline
                          icon
                          color="info"
                          v-on="on"
                          @click="editItem(props.item)"
                        >
                          <v-icon small>edit</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('general.edit') }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              round
              flat
              @click="closeDialogSelectExpenses"
              color="primary darken-1"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              round
              color="primary"
              :loading="loadingSelectExpenses"
              :disabled="loadingSelectExpenses"
              v-if="expense !== null"
              @click="restoreExpense()"
            >
              {{ $t('general.accept') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogExpenses" max-width="600px" persistent>
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ formTitle }}
            </h2>
          </v-toolbar>
          <v-card-text>
            <v-form lazy-validation ref="form" v-model="valid">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-menu
                      v-model="startDate"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          clearable
                          required
                          :rules="rules.required"
                          v-model="editedItem.start_date"
                          :label="$t('general.startDate')"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        >
                        </v-text-field>
                      </template>
                      <v-date-picker
                        :locale="$t('general.locale')"
                        v-model="editedItem.start_date"
                        @input="start = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-menu
                      v-model="endDate"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          clearable
                          required
                          :rules="rules.required"
                          v-model="editedItem.end_date"
                          :label="$t('general.endDate')"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        >
                        </v-text-field>
                      </template>
                      <v-date-picker
                        :locale="$t('general.locale')"
                        v-model="editedItem.end_date"
                        @input="end = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <!-- <v-flex xs12 sm12 md12>
                    <v-text-field
                      clearable
                      required
                      :rules="rules.required"
                      :label="$t('expenseDetailEmployee.employee')"
                      disabled
                    >
                    </v-text-field>
                  </v-flex> -->
                  <v-flex xs12 sm12 md12>
                    <v-select
                      v-model="editedItem.project_id"
                      :label="$t('general.project')"
                      :items="projectsFilter"
                      item-value="id"
                      item-text="name"
                      :rules="rules.required"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      clearable
                      required
                      :rules="rules.required"
                      :label="$t('general.description')"
                      v-model="editedItem.description"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-radio-group v-model="type" row>
                      <v-radio v-if="pettyCashAmount" :disabled="isDisabledPettyCash" :label="$t('pettyCash.title')" value="pettyCash"></v-radio>
                      <v-radio v-if="amexCardAmount" :disabled="isDisabledAmexCard" :label="$t('amexCard.title')" value="amexCard"></v-radio>
                      <v-radio :disabled="isDisabledAdvance" :label="$t('general.advanceExpense')" value="advance"></v-radio>
                      <v-radio :disabled="isDisabledRefund" :label="$t('general.refund')" value="refund"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-text-field
                      v-if="type === 'advance'"
                      :disabled="editable || isPettyCash"
                      clearable
                      required
                      prepend-icon="attach_money"
                      :rules="rules.digit"
                      :persistent-hint="true"
                      :label="
                        $t('general.advance') + $t('general.optionalField')
                      "
                      v-model="editedItem.advance"
                    >
                    </v-text-field>
                  </v-flex>
                  <!-- <v-flex xs4 sm4 md4 v-if="editedIndex === -1">
                    <v-checkbox
                      color="primary"
                      :label="$t('expenses.toPettyCash')"
                      v-model="isPettyCash"
                      :value="true"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs8 sm8 md8>
                    <v-text-field
                      :disabled="isPettyCash"
                      clearable
                      required
                      prepend-icon="attach_money"
                      :rules="rules.digit"
                      :label="$t('general.advance') + $t('general.optionalField')"
                      v-model="editedItem.advance">
                    </v-text-field>
                  </v-flex> -->
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-1"
              round
              flat
              @click="closeDialogExpense"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              round
              depressed
              :loading="loading"
              :disabled="loading"
              @click="save"
            >
              {{ $t('general.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog" max-width="600px" persistent>
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ formTitle }}
            </h2>
          </v-toolbar>
          <v-card-text>
            <v-form lazy-validation ref="form" v-model="valid">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-menu
                      v-model="start"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :disabled="editable"
                          clearable
                          required
                          :rules="rules.required"
                          :error-messages="errors.start_date"
                          v-model="editedItem.start_date"
                          :label="$t('general.startDate')"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        >
                        </v-text-field>
                      </template>
                      <v-date-picker
                        color="primary"
                        :locale="$t('general.locale')"
                        v-model="editedItem.start_date"
                        :max="maxDate"
                        @input="start = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-menu
                      v-model="end"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :disabled="editable"
                          clearable
                          required
                          :rules="rules.required"
                          v-model="editedItem.end_date"
                          :error-messages="errors.end_date"
                          :label="$t('general.endDate')"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        >
                        </v-text-field>
                      </template>
                      <v-date-picker
                        color="primary"
                        :locale="$t('general.locale')"
                        v-model="editedItem.end_date"
                        :min="minDate"
                        @input="end = false"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-autocomplete
                      v-model="editedItem.project_id"
                      required
                      :rules="rules.required"
                      :error-messages="errors.project_id"
                      :label="$t('general.project')"
                      :items="projects"
                      item-value="id"
                      item-text="name"
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-text-field
                      :disabled="editable"
                      clearable
                      required
                      :rules="rules.required"
                      :error-messages="errors.description"
                      :label="$t('general.description')"
                      v-model="editedItem.description"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-radio-group v-model="type" row>
                      <v-radio v-if="pettyCashAmount" :disabled="isDisabledPettyCash" :label="$t('pettyCash.title')" value="pettyCash"></v-radio>
                      <v-radio v-if="amexCardAmount" :disabled="isDisabledAmexCard" :label="$t('amexCard.title')" value="amexCard"></v-radio>
                      <v-radio :disabled="isDisabledAdvance" :label="$t('general.advanceExpense')" value="advance"></v-radio>
                      <v-radio :disabled="isDisabledRefund" :label="$t('general.refund')" value="refund"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs6 sm6 md6>
                    <v-text-field
                      v-if="type === 'advance'"
                      :disabled="editable || isPettyCash"
                      clearable
                      required
                      prepend-icon="attach_money"
                      :rules="rules.digit"
                      :persistent-hint="true"
                      :label="
                        $t('general.advance') + $t('general.optionalField')
                      "
                      v-model="editedItem.advance"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" round flat @click="closeDialog">
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              color="primary"
              round
              depressed
              :loading="loading"
              :disabled="loading || editable"
              @click="saveExpense"
            >
              {{ $t('general.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">
              {{ $t('viatics.deleteTitle') }}
            </h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>
              {{ $t('viatics.deleteQuestion')
              }}<strong>: {{ deleteItem.id }}</strong
              >{{ '?' }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="dialogDelete = false"
            >
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="deleteRequest()"
            >
              {{ $t('viatics.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
import vue2Dropzone from 'vue2-dropzone'
export default {
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      deleteItem: {},
      dialogDelete: false,
      type: 'refund',
      errors: {},
      isDisabledPettyCash: false,
      isDisabledAdvance: false,
      isDisabledRefund: false,
      isDisabledAmexCard: false,
      search: '',
      itemsBackIds: [],
      dialogNoFiscal: false,
      dialogFiscal: false,
      dialogExpenses: false,
      dialogRedirect: false,
      dialogComment: false,
      dialogSelectExpenses: false,
      dialog: false,
      viewImg: false,
      start: false,
      end: false,
      startDate: false,
      endDate: false,
      valid: true,
      valid2: true,
      valid3: true,
      validR: true,
      error: false,
      errorMessage: '',
      datemenu: false,
      loading: false,
      loadingSelectExpenses: false,
      loadingItems: true,
      disabled: false,
      isPettyCash: false,
      comment: {},
      putItem: {
        gst_categories: {},
        country: {},
        currency: {},
        sat_forma_pago: {},
        receipt_type: {},
      },
      putItemF: {
        gst_categories: {},
        country: {},
        currency: {},
        sat_forma_pago: {},
        sat_metodo_pago: {},
        receipt_type: {},
      },
      editedIndex: -1,
      userLogged: {},
      itemsBack: [],
      userItems: [],
      editedItem: {
        id: null,
        user_id: null,
        start_date: '',
        end_date: '',
        description: '',
        project_id: '',
        status: '',
        expenses_status: '',
        advance: '',
        is_petty_cash: 0,
      },
      defaultItem: {
        id: null,
        user_id: null,
        start_date: '',
        end_date: '',
        description: '',
        project_id: '',
        status: '',
        expenses_status: '',
        advance: '',
        is_petty_cash: 0,
      },
      postItems: {
        expenses_id: null,
        item_back_id: null,
      },
      dataURL: null,
      projects: [],
      categories: [],
      satFormaPago: [],
      satMetodoPago: [],
      satMoneda: [],
      satPais: [],
      expenses: [],
      expensesOpen: [],
      expense: {
        id: null,
      },
      selected: [],
      start_date: new Date().toISOString().substr(0, 10),
      end_date: new Date().toISOString().substr(0, 10),
      date: new Date().toISOString().substr(0, 10),
      dropzoneOptions: {
        url: process.env.HOST + 'api/File',
        dictDefaultMessage: this.$t('dropzone.default', {
          size: '5',
          unit: 'MB',
        }),
        dictResponseError: this.$t('dropzone.responseError'),
        dictFileTooBig: this.$t('dropzone.fileTooBig'),
        dictInvalidFileType: this.$t('dropzone.invalidFileType'),
        dictRemoveFile: this.$t('dropzone.removeFile'),
        dictRemoveFileConfirmation: this.$t('dropzone.removeFileConfirmation'),
        dictMaxFilesExceeded: this.$t('dropzone.maxFilesExceeded'),
        addRemoveLinks: true,
        thumbnailWidth: 150,
        maxFilesize: 5,
        paramName: 'path',
        acceptedFiles: '.jpeg,.jpg,.png,.pdf',
        maxFiles: 1,
        headers: {
          Authorization: 'Bearer ' + this.$store.state.userState.access_token,
        },
        params: {
          user_id: this.$store.state.userLogged.id,
          dirname: 'IMG_EXPENSES',
        },
      },
      rowsPerPageItems: [4, 8, 12],
      pagination: {
        rowsPerPage: 15,
        sortBy: 'id',
        descending: true,
      },
      paginationExpenses: {
        rowsPerPage: -1,
        sortBy: 'id',
        descending: true,
      },
      showMessageAddItem: false,
      settings: {},
    }
  },
  mounted() {
    if (localStorage.getItem('expenses')) {
      try {
        this.expenses = JSON.parse(localStorage.getItem('expenses'))
      } catch (e) {
        localStorage.clear('expenses')
      }
    }
  },
  created() {
    this.getLogged()
  },
  beforeDestroy() {
    this.clearLocalStorage()
  },
  computed: {
    pettyCashAmount() {
      if (!this.$store.state.userLogged.small_box) return 0;
  
      const found = this.$store.state.userLogged.small_box.find(x => x.type === 1)
      return found ? found.amount : 0
    },
    amexCardAmount() {
      if (!this.$store.state.userLogged.small_box) return 0

      const found = this.$store.state.userLogged.small_box.find(x => x.type === 2)
      return found ? found.amount : 0
    },
    editable() {
      if (this.editedIndex > -1) {
        if (
          this.editedItem.created_by &&
          this.editedItem.created_by.id !== this.$store.state.userLogged.id
        ) {
          return true
        } else {
          return false
        }
      }
    },
    minDate() {
      let minDate = ''
      if (
        this.editedItem.start_date !== '' &&
        this.editedItem.start_date !== null
      ) {
        minDate = new Date(this.editedItem.start_date)
          .toISOString()
          .substr(0, 10)
      }
      return minDate
    },
    maxDate() {
      let maxDate = ''
      if (
        this.editedItem.end_date !== '' &&
        this.editedItem.end_date !== null
      ) {
        maxDate = new Date(this.editedItem.end_date).toISOString().substr(0, 10)
      }
      return maxDate
    },
    heading() {
      return this.$t('general.rejected')
    },
    subheading() {
      return ''
    },
    headers() {
      return [
        {
          text: '#',
          align: 'center',
          value: 'id',
          sortable: false,
        },
        {
          text: this.$t('workflowValidation.typeItem'),
          align: 'center',
          value: 'gst_receipt_type_id',
          sortable: true,
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: true,
        },
        {
          text: this.$t('general.supplier'),
          align: 'center',
          value: 'validator_comment',
          sortable: true,
        },
        {
          text: this.$t('pettyCash.amount'),
          align: 'center',
          value: 'total',
          sortable: true,
        },
        {
          text: 'Amex',
          align: 'center',
          value: 'expenses_amex_id',
          sortable: true,
        },
        {
          text: this.$t('conciliation.statusLabel'),
          align: 'center',
          value: 'validator_comment',
          sortable: true,
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    headers2() {
      return [
        {
          text: '#',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: true,
        },
        {
          text: 'Rango de fecha',
          align: 'center',
          value: 'start_date',
          sortable: true,
        },
        {
          text: 'Proyecto',
          align: 'center',
          value: 'project.name',
          sortable: true,
        },
        {
          text: 'Anticipo',
          align: 'center',
          value: 'advance',
          sortable: true,
        },
      ]
    },
    addingHeaders() {
      return [
        {
          text: '#',
          align: 'center',
          value: 'id',
          sortable: true,
        },
        {
          text: this.$t('workflowValidation.typeItem'),
          align: 'center',
          value: 'gst_receipt_types_id',
          sortable: true,
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: true,
        },
        {
          text: this.$t('workflowValidation.commentV'),
          align: 'center',
          value: 'validator_comment',
          sortable: true,
        },
      ]
    },
    expensesHeaders() {
      return [
        {
          text: '#',
          align: 'center',
          sortable: true,
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: true,
        },
        {
          text: '',
          align: 'center',
          sortable: false,
        },
      ]
    },
    icon() {
      return 'far fa-times-circle fa-fw icon-color'
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t('expenses.new')
        : this.$t('expenses.edit')
    },
    title() {
      return this.$t('workflowValidation.add')
    },
    /* titleRedirect () {
      return this.$t('workflowValidation.')
    } */
    projectsFilter() {
      return this.projects.filter(
        (project) => project.company_id === this.userLogged.company[0].id
      )
    },
    rules() {
      return this.$validationRules()
    },
    tagCurrency(){
      if(this.settings !== undefined && this.settings.length > 0){  
        let currency = this.settings.find(x => x.setting_type.name == "st.currency" && x.company_id == this.$store.state.userLogged.company[0].id)
        return currency === undefined ? 'MXN' : currency.value.c_Moneda
      }

      return ''
    }
  },
  watch: {
    userLogged() {
      this.get()
      this.getExpensesOpen()
    },
    dialog(val) {
      val || this.close()
    },
    viewImg() {
      if (this.viewImg === false) {
        this.reset()
      }
    },
    expensesPost() {
      this.expenses.push(this.expensesPost)
      this.saveExpenses()
    },
    '$store.state.userLogged'() {
      this.getLogged()
      this.dropzoneOptions.params.user_id = this.$store.state.userLogged.id
    },
    itemsBack() {
      if (this.itemsBack.length < 1) {
        this.expenses = []
      }
    },
    type() {
      if (this.type === 'pettyCash') {
        this.editedItem.advance = ''
        this.editedItem.is_petty_cash = 1
      } else if (this.type === 'advance') {
        this.editedItem.is_petty_cash = 0
      } else if (this.type === 'refund') {
        this.editedItem.advance = ''
        this.editedItem.is_petty_cash = 0
      }
    },
  },
  methods: {
    deleteRequest() {
      this.$emit('delete', {
        id: this.deleteItem.id,
        context: this,
      })
    },
    confirmDelete(item) {
      this.deleteItem = Object.assign({}, JSON.parse(JSON.stringify(item)))
      this.dialogDelete = true
    },
    disabledButtons(item) {
      this.isDisabledPettyCash = true
      this.isDisabledOkBlue = true
      this.isDisabledAdvance = true
      this.isDisabledRefund = true
      this.isDisabledAmexCard = true

      if (item.is_blue_voucher === 1 && item.petty_cash_type === 0) {
        this.type = 'okBlue'
        this.isDisabledOkBlue = false
        return
      } 
      
      if (item.petty_cash_type === 1) {
        this.type = 'pettyCash'
        this.isDisabledPettyCash = false
        this.isDisabledOkBlue = item.is_blue_voucher === 0
        return
      }  
      
      if (item.petty_cash_type === 2) {
        this.type = 'amexCard'
        this.isDisabledAmexCard = false
        this.isDisabledOkBlue = item.is_blue_voucher === 0
        return
      }

      if (item.advance !== '0.00') {
        this.type = 'advance'
        this.isDisabledAdvance = false
        return
      } 
      
      if (item.advance === '0.00' && item.petty_cash_type === 0 && item.is_blue_voucher === 0) {
        this.type = 'refund'
        this.isDisabledRefund = false
        return
      }
    },
    editItem(item) {
      this.disabledButtons(item)
      this.editedIndex = this.expensesOpen.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    restoreExpense() {
      if(this.expense.id === null) return this.showNotification(this.$t('expenses.selectedExpense'), 'error', -1)
      this.loadingSelectExpenses = true
      if (this.selected.length > 0) {
        this.selected.forEach((expense) => {
          this.itemsBackIds.push(expense.id)
        })
      }
      
      this.$emit('restoreExpense', {
        gst_expenses_id: this.expense.id,
        gst_expenses_items_back_ids: this.itemsBackIds,
        context: this,
      })
    },
    restoreExpenseFromEdit(itemExpenseId) {
      this.loadingSelectExpense = true
      if (this.expense.id !== null && itemExpenseId !== null) {
        this.itemsBackIds.push(itemExpenseId)
        this.$emit('restoreExpense', {
          gst_expenses_id: this.expense.id,
          gst_expenses_items_back_ids: this.itemsBackIds,
          context: this,
        })
      }
    },
    showDialogExpenses() {
      this.dialogExpenses = true
    },
    selectRow(item) {
      this.expense = item
      const prevItem = this.expensesOpen.find((expense) => expense.isSelected)
      if (prevItem) this.$set(prevItem, 'isSelected', false)
      this.$set(item, 'isSelected', true)
    },
    showDialogSelectExpenses() {
      if (this.selected.length > 0) {
        this.getExpensesOpen()
        this.dialogSelectExpenses = true
      }
    },
    getExpensesOpen() {
      this.$emit('getExpensesOpen', {
        context: this,
      })
    },
    getLogged() {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
      }
    },
    clearLocalStorage() {
      localStorage.removeItem('expenses')
    },
    isPDF(data) {
      if (data !== null) {
        let type = data.slice(data.indexOf('/') + 1, data.indexOf(';'))
        if (type === 'pdf') {
          return true
        } else {
          return false
        }
      }
    },
    openPDF() {
      var tab = window.open()
      tab.document.write(
        '<body style="margin: 0;"> <iframe src="' +
          this.dataURL +
          '" frameborder="0" style="margin: 0; padding: 0; border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;"</iframe></body>'
      )
    },
    addItems(expense) {
      this.expense = Object.assign({}, expense)
      this.dialogRedirect = true
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.itemsBack.slice()
    },
    changeSort(header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    fileAdded(file) {
      this.dropzoneOptions.params.user_id = this.$store.state.userLogged.id
      let fileType = file.type
      if (fileType === 'image/jpeg') {
        this.dropzoneOptions.params.files_type_id = 5
      } else if (fileType === 'image/png') {
        this.dropzoneOptions.params.files_type_id = 6
      } else if (fileType === 'application/pdf') {
        this.dropzoneOptions.params.files_type_id = 3
      }
    },
    fileUpload(file, response) {
      this.putItem.fileId = response.data.id
    },
    fileUploadError(file, message, xh) {
      this.showNotification(message, 'error', -1)
      this.errorMessage = message.errors.path[0]
    },
    close() {
      this.viewImg = false
      this.selected = []
      this.reset()
      this.dialogFiscal = false
      this.dataURL = null
      this.editedItem = Object.assign({}, this.defaultItem)
      this.expense.id = null
      this.dialogNoFiscal = false
      this.dialogExpenses = false
      this.dialogRedirect = false
      this.dialogComment = false
      this.loading = false
      this.disabled = false
      this.errors = {}
      this.editedIndex = -1
    },
    closeDialogExpense() {
      this.dialogExpenses = false
      this.editedIndex = -1
      this.editedItem = Object.assign({}, this.defaultItem)
    },
    closeDialog() {
      this.dialog = false
      this.loading = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.type = 'refund'
      this.isDisabledPettyCash = false
      this.isDisabledAdvance = false
      this.isDisabledRefund = false
      this.isDisabledAmexCard = false
    },
    closeDialogSelectExpenses() {
      this.dialogSelectExpenses = false
      this.loadingSelectExpenses = false
      this.dialogNoFiscal = false
      this.itemsBackIds = []
    },
    closePost() {
      this.dialogRedirect = false
      this.loading = false
      this.disabled = false
      this.isPettyCash = false
    },
    createExpenses() {
      this.dialogExpenses = true
    },
    viewItem(item) {
      this.putItem = Object.assign({}, item)
      if (this.putItem.gst_expenses_items_files_back.length > 0) {
        let id = this.putItem.gst_expenses_items_files_back[0].files_id
        this.$store.dispatch('getFile', {
          event: {
            context: this,
            fileId: id,
          },
        })
      }
      this.dialogNoFiscal = true
    },
    viewItemf(item) {
      this.putItemF = Object.assign({}, item)
      this.dialogFiscal = true
    },
    viewComment(item) {
      this.comment = Object.assign({}, item)
      this.dialogComment = true
    },
    save() {
      if (this.$refs.form.validate()) {
        this.post()
        this.loading = true
        this.disabled = true
      }
    },
    saveExpense() {
      this.errors = {}
      if (this.$refs.form.validate()) {
        this.loading = true
        if (this.editedIndex > -1) {
          this.putExpense()
        } else {
          this.postExpense()
        }
      }
    },
    postExpense() {
      this.$emit('postExpense', {
        item: this.editedItem,
        user: this.userLogged,
        context: this,
      })
    },
    putExpense() {
      this.$emit('putExpense', {
        item: this.editedItem,
        index: this.editedIndex,
        context: this,
      })
    },
    saveRedirect() {
      this.postItems.expenses_id = this.expense.id
      let itemsArray = []
      this.selected.forEach((item) => {
        itemsArray.push({ id: item.id })
      })
      this.postItems.items_back_id = itemsArray
      this.redirectItems()
      this.loading = true
      this.disabled = true
    },
    saveExpenses() {
      const parsed = JSON.stringify(this.expenses)
      localStorage.setItem('expenses', parsed)
    },
    saveEdit() {
      if (this.$refs.formNF.validate()) {
        this.putNF()
        this.loading = true
        this.disabled = true
      }
    },
    saveEditF() {
      if (this.$refs.formF.validate()) {
        this.putF()
      }
    },
    reset() {
      if (this.$refs.dropzone !== undefined) {
        this.$refs.dropzone.removeAllFiles()
      }
    },
    get() {
      this.$emit('get', {
        user: this.userLogged,
        id: this.userLogged.company[0].id,
        context: this,
      })
    },
    post() {
      this.editedItem.has_advance = this.type
      this.$emit('post', {
        item: this.editedItem,
        user: this.userLogged,
        context: this,
      })
    },
    putNF() {
      this.$emit('put', {
        itemR: this.putItem,
        context: this,
      })
    },
    putF() {
      this.$emit('put', {
        itemR: this.putItemF,
        context: this,
      })
    },
    redirectItems() {
      this.$emit('redirectItems', {
        redirect: this.postItems,
        context: this,
      })
    },
    refresh() {
      this.$emit('refresh', {
        user: this.userLogged,
        context: this,
      })
    },
    countryFilter(item, queryText, itemText) {
      const description = item.descripcion.toLowerCase()
      const abbr = item.c_Pais.toLowerCase()
      const searchText = queryText.toLowerCase()
      return (
        description.indexOf(searchText) > -1 || abbr.indexOf(searchText) > -1
      )
    },
    currencyFilter(item, queryText, itemText) {
      const description = item.descripcion.toLowerCase()
      const abbr = item.c_Moneda.toLowerCase()
      const searchText = queryText.toLowerCase()
      return (
        description.indexOf(searchText) > -1 || abbr.indexOf(searchText) > -1
      )
    },
    getSatFormaPago(value) {
      return this.satFormaPago.find((element) => element.c_FormaPago === value)
    },
    getSatMetodoPago(value) {
      return this.satMetodoPago.find(
        (element) => element.c_MetodoPago === value
      )
    },
    getCurrency(value) {
      return this.satMoneda.find((element) => element.c_Moneda === value)
    },
    getProject(value) {
      return this.projects.find((element) => element.id === value)
    },
    getCountry(value) {
      return this.satPais.find((element) => element.c_Pais === value)
    },
    textSelectedItem({ name, id }) {
      name = this.$t('workflowValidation.item')
      return `${name} ${id}`
    },
    textSelectedExpense({ name, id }) {
      name = this.$t('workflowValidation.expense')
      return `${name} ${id}`
    },
  },
}
</script>

<style scoped>
.borde_error {
  border: 8px solid rgba(235, 33, 33, 0.89) !important;
  border-radius: 10px !important;
}
.color_error {
  background-color: rgb(197, 16, 16) !important;
}

p {
  margin-bottom: 0px !important;
}

.selectedRow {
  background-color: #93d2f2 !important;
}

.rowExpense {
  cursor: pointer;
}
.fontSize{
  font-size: 10px
}
</style>



// WEBPACK FOOTER //
// src/components/user.expensesRejected.component.vue